import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IconChevron } from '../../icon/IconChevron';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import {
    MULTIPLE_THUMB_HEIGHT,
    MULTIPLE_THUMB_WIDTH,
    THUMB_HEIGHT,
    THUMB_WIDTH,
} from './constants';
import { OverlayLinkProps } from './types';

export const OverlayLink = styled(Button)
    .withConfig({ displayName: 'OverlayLink' })
    .attrs<OverlayLinkProps>((props) => ({
        ...props,
        as: Link,
        padding: '0px',
        height: 'fit-content',
        width: '100%',
        borderRadius: '24px',
        target: '_blank',
        variant: 'filled',
        color: 'secondary',
        textTransform: 'none',
        textAlign: 'left',
    }))<OverlayLinkProps>``;

export const ImageWrapper = styled(Box)
    .withConfig({ displayName: 'ImageWrapper' })
    .attrs<{ isMultipleProducts?: boolean }>(({ isMultipleProducts }) => ({
        height: isMultipleProducts ? MULTIPLE_THUMB_HEIGHT : THUMB_HEIGHT,
        width: isMultipleProducts ? MULTIPLE_THUMB_WIDTH : THUMB_WIDTH,
        minWidth: isMultipleProducts ? MULTIPLE_THUMB_WIDTH : THUMB_WIDTH,
        borderRadius: isMultipleProducts ? '20px' : '16px',
        backgroundColor: 'var(--always-white)',
        overflow: 'hidden',
    }))`
    align-content: center;
`;

export const Content = styled(Flex)
    .withConfig({ displayName: 'Content' })
    .attrs<{ isMultipleProducts?: boolean }>(({ isMultipleProducts }) => ({
        direction: 'column',
        width: '100%',
        margin: `auto 0 auto ${isMultipleProducts ? '12px' : '16px'}`,
        p: 0.5,
    }))``;

export const Chevron = styled(IconChevron).withConfig({ displayName: 'Chevron' }).attrs({
    size: 24,
    color: 'var(--color-primary)',
})`
    transform: rotate(-90deg);
    margin: auto 4px auto 0;
`;

export const ChevronMultiple = styled(Button).withConfig({
    displayName: 'ChevronMultiple',
})`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: 8px 4px 8px 16px;
    flex-shrink: 0;
`;
